export const BORDER_RADIUS = '24px';
export const HOVER_TRANSFORM = 'scale(1.005)';
export const TRANSITION_DURATION = '2s';
export const CLICK_DELAY = 150;

export const cardContentStyle = {
  position: 'absolute',
  bottom: 0,
  left: 0,
  right: 0,
  width: '100%',
  height: '100%',
  padding: '16px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-end',
  alignItems: 'flex-start',
  boxSizing: 'border-box',
  overflow: 'hidden'
};

export const backgroundPattern = {
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundImage: 'radial-gradient(circle at 50% 50%, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0) 100%)',
  opacity: 0.5,
  pointerEvents: 'none'
};

// Title wrapper styles
export const titleWrapperStyle = {
  width: '100%',
  marginBottom: '8px'
};

// Title image styles
export const titleImageStyle = {
  width: '100%',
  maxWidth: '300px',
  height: 'auto',
  objectFit: 'contain'
};

// Special title image styles
export const specialTitleImageStyle = {
  width: '100%',
  maxWidth: '400px',
  height: 'auto',
  objectFit: 'contain'
};

// ... (rest of the style constants) 